var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_vm._t("default",null,{"changePicker":_vm.changePicker,"initPicker":_vm.initPicker})],2)}
var staticRenderFns = []

export { render, staticRenderFns }